export default function ClipboardLines(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.0106 2.99121V18.5681H2.99219V2.99121H6.88437C6.88652 3.40389 7.05141 3.79906 7.34322 4.09087C7.63503 4.38269 8.0302 4.54757 8.44288 4.54972H11.5599C11.7643 4.55115 11.9668 4.51061 12.1549 4.43061C12.3429 4.3506 12.5126 4.23284 12.6533 4.08461C12.8015 3.94389 12.9193 3.77424 12.9993 3.58617C13.0793 3.39809 13.1198 3.19559 13.1184 2.99121H17.0106Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M13.1168 2.99112C13.1183 3.1955 13.0777 3.398 12.9977 3.58608C12.9177 3.77416 12.8 3.94381 12.6517 4.08453C12.511 4.23275 12.3414 4.35052 12.1533 4.43052C11.9652 4.51052 11.7627 4.55106 11.5583 4.54963H8.44132C8.02864 4.54749 7.63347 4.3826 7.34166 4.09079C7.04984 3.79897 6.88496 3.40381 6.88281 2.99112C6.88706 2.5791 7.05262 2.18515 7.34399 1.89379C7.63535 1.60243 8.0293 1.43687 8.44132 1.43262H11.5583C11.971 1.43476 12.3662 1.59965 12.658 1.89146C12.9498 2.18328 13.1147 2.57844 13.1168 2.99112Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M5.32422 8.44141H14.6753"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M5.32422 11.5586H14.6753"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M5.32422 14.6758H10.7749"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	)
}
